import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './Sidebar.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const Sidebar: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <aside className={concatClassName(styles['sidebar'], className)}>
        {children}
    </aside>
);

Sidebar.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

Sidebar.defaultProps = {
    className: undefined,
    children: undefined
};

export default Sidebar;
